import React from "react";
import { BedDouble, CalendarPlus, ClipboardCheck, LogOut, Stethoscope, UserCheck } from "lucide-react";
import Reveal from "./Reveal";

const STEPS = [
  { icon: CalendarPlus, title: "Book", body: "Patient books online or at the desk. The slot is locked instantly.", who: "Patient · Front desk" },
  { icon: UserCheck, title: "Check in", body: "Arrival is marked and the doctor's queue updates in real time.", who: "Front desk" },
  { icon: Stethoscope, title: "Consult", body: "In person or on video, with history and vitals in front of the doctor.", who: "Doctor" },
  { icon: ClipboardCheck, title: "Prescribe & bill", body: "Coded e-prescription, lab orders and an OPD bill in a few clicks.", who: "Doctor · Billing" },
  { icon: BedDouble, title: "Admit if needed", body: "Pick a free bed, take an advance, chart notes, vitals and charges daily.", who: "Ward · Nursing" },
  { icon: LogOut, title: "Discharge", body: "Summary, advice and the final IPD bill generated together. Bed goes to housekeeping.", who: "Doctor · Billing" },
];

const Journey = () => (
  <section id="journey" className="relative overflow-hidden bg-ink-900 py-24 text-slate-300 sm:py-28">
    <div className="pointer-events-none absolute inset-0">
      <div className="bg-grid absolute inset-0 opacity-[0.07] [filter:invert(1)]" />
      <div className="absolute -left-40 top-0 h-96 w-96 rounded-full bg-brand-600/30 blur-3xl" />
      <div className="absolute -right-40 bottom-0 h-96 w-96 rounded-full bg-care-500/20 blur-3xl" />
    </div>
    <div className="container-x relative">
      <Reveal className="mx-auto max-w-2xl text-center">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-care-300">
          The complete patient journey
        </span>
        <h2 className="section-title !text-white">From first booking to final bill — connected</h2>
        <p className="mt-4 text-lg text-slate-400">Each step hands over to the next automatically, so information follows the patient instead of paper files.</p>
      </Reveal>

      <ol className="relative mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {STEPS.map((s, i) => (
          <Reveal as="li" key={s.title} delay={i * 0.06} className="relative rounded-2xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur transition hover:border-white/25 hover:bg-white/[0.07]">
            <div className="flex items-center justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-brand-500 to-care-500 text-white shadow-glow">
                <s.icon className="h-5 w-5" />
              </span>
              <span className="font-display text-4xl font-extrabold text-white/10">{String(i + 1).padStart(2, "0")}</span>
            </div>
            <h3 className="mt-5 text-lg font-bold !text-white">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.body}</p>
            <p className="mt-4 text-xs font-medium text-care-300">{s.who}</p>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);

export default Journey;
